/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
    <footer>
  {/* footer-area-start */}
  <div className="tp-footer-2__area tp-footer-2__bg pt-30">
    <div className="container">
      <div className="tp-footer-2__ptb">
        <div className="row">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
            <div className="tp-footer-2__widget footer-col-5">
              <div className="tp-footer-2__logo">
                <Link to={'home'}><img src="assets/img/gallery/Isolation_Mode (2).png" alt /></Link>
              </div>
              <div className="tp-footer-2__text">
                <p>Download app</p>
              </div>
              <div className="tp-footer-2__contact-list">
                <p className="text-white">
                  #1 Rated App for printed photographs on canvas
                </p>
                <div className="d-flex align-items-center gap-3">
                  <Link to={"https://play.google.com/store/apps/details?id=com.printlific.app&pcampaignid=web_share"} target="_blank">
                    <img src="assets/img/gallery/Group 3181 1.png" alt className="footer-app-icon" />
                  </Link>
                  <Link to={"https://apps.apple.com/us/app/printlific/id6793495810"} target="_blank">
                    <img src="assets/img/gallery/Group 3181 2.png" alt className="footer-app-icon pointer"/>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".5s">
            <div className="tp-footer-2__widget footer-col-6">
              <h4 className="tp-footer-2__widget-title">Information</h4>
              <div className="tp-footer-2__list">
                <ul>
                  {/* <li> <Link to={"giftCards"}>Gift Cards</Link></li> */}
                  <li> <Link to={"ourArtCanvas"}>Our Art Canvas</Link></li>
                  <li><Link to={"affiliateProgram"}>Affiliate Program</Link></li>
                  <li><Link to={"privacy-policy"} target="_blank">Privacy Policy</Link></li>
                  
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".7s">
            <div className="tp-footer-2__widget footer-col-7">
              <h4 className="tp-footer-2__widget-title">Navigation</h4>
              <div className="tp-footer-2__list">
                <ul>
                  {/* <li><Link to={'canvasOptions'}>Canvas Options</Link></li> */}
                  {/* <li><Link to={"prices"}>Prices</Link></li> */}
                  <li><Link to={"about"}>About Us</Link></li>
                  <li><Link to={"contact"}>Contact us</Link></li>
                  <li><Link to={"questions"}>Questions</Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".7s">
            <div className="tp-footer-2__widget footer-col-7">
              <h4 className="tp-footer-2__widget-title">Contact</h4>
              <div className="tp-footer-2__list">
                <ul>
                  <li>
                    <span className="heart p-relative pr-10">
                      <i className="fa-regular fa-map-marker text-white" />
                      {/* <b class="tp-header__icon-text"></b> */}
                    </span>
                    <Link>5767 Major Blvd, Orlando Fl.  32819</Link></li>
                  <li>
                    <span className="heart p-relative pr-10">
                      <i className="fa-regular fa-phone text-white" />
                      {/* <b class="tp-header__icon-text"></b> */}
                    </span>
                    <Link>+1 (917) 386-4948</Link></li>
                  <li>
                    <span className="heart p-relative pr-10">
                      <i className="fa-regular fa-envelope text-white" />
                      {/* <b class="tp-header__icon-text"></b> */}
                    </span>
                    <Link>info@Printlific.com</Link></li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-3 col-md-6 col-sm-6 mb-50  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".7s">
            <h4 className="tp-footer-2__widget-title">Social</h4>
            <div className="tp-footer-2__social-box">
              {/* <Link><i className="fa-brands fa-apple" /></Link> */}
              <Link to={'https://www.facebook.com/Iphotocanvas/'} target="_blank"><i className="fa-brands fa-facebook-f" /></Link>
              <Link><i className="fa-brands fa-skype" /></Link>
              <Link><i className="fa-brands fa-twitter" /></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* footer-area-end */}
  {/* copyright-area-start */}
  <div className="tp-copyright-2__area black-bg-2 ">
    <div className="container">
      <div className="tp-copyright-2__bdr">
        <div className="row align-items-center">
          <div className="col-xl-12 col-lg-6 col-md-6 text-center  wow tpfadeUp" data-wow-duration=".9s" data-wow-delay=".3s">
            <div className="tp-copyright-2__text text-center ">
              <span><strong className="text-white">
                Copyright All Rights Reserved ©{" "}
          {2026 === new Date().getFullYear()
            ? "2026"
            : `2026-${String(new Date().getFullYear()).slice(-2)}`}
                </strong> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* copyright-area-end */}
</footer>

    </>
  );
}
